import { Box, Card, CardContent, Modal, Typography } from '@mui/material'
import ButtonCustom from '../../atoms/button/ButtonCustom'

export const PushEventsModal = ({
	open,
	toggleModal,
	pushConflictingEvents,
}) => {
	const handleClose = () => {
		toggleModal(false)
	}

	return (
		<Modal open={open}>
			<Box
				sx={{
					display: 'flex',
					position: 'absolute',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					maxWidth: '500px',
					width: '95%',
					borderRadius: '0.5rem',
					outline: 'none',
					minHeight: '170px',
				}}
				className="push-events-modal"
			>
				<Card
					sx={{
						display: 'flex',
						flexGrow: 1,
						borderRadius: '1rem',
					}}
				>
					<CardContent
						sx={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							justifyContent: 'space-around',
							gap: '25px',
							padding: '25px',
						}}
					>
						<Typography
							variant="h5"
							sx={{
								textAlign: 'center',
								fontWeight: '500',
								fontSize: '18px',
								fontFamily: 'Inter',
							}}
						>
							The current event overlaps with another event. Would
							you like to push conflicting events forward? 
                            (If you don't see the overlapping event, you are currently
                            moving a linked event that has overlap on another calendar)
						</Typography>
						<Box
							sx={{
								display: 'flex',
								gap: '15px',
							}}
						>
							<ButtonCustom
								variant="destructive"
								size="lg"
								onClick={() => {
									pushConflictingEvents()
									handleClose()
								}}
								style={{
									minWidth: '90px',
								}}
							>
								Yes
							</ButtonCustom>
							<ButtonCustom
								variant="outlined"
								size="lg"
								onClick={handleClose}
								style={{
									minWidth: '90px',
								}}
							>
								No
							</ButtonCustom>
						</Box>
					</CardContent>
				</Card>
			</Box>
		</Modal>
	)
}
